var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.947 21.71l1.461-1.384-8.417-8.135H24.5v-1.965H3.99l8.414-8.135L10.942.708.797 10.518a.961.961 0 00-.297.691c0 .259.107.508.297.691l10.15 9.81z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "arrow-left-4bc7ca09f5a12ee6749218374c9bdff8.svg";
export { SvgArrowLeft as ReactComponent };